export default __webpack_public_path__ + "static/cat-astronaut-39e96cef4f18110061d457d92a9431cc.png";